<section class="page-wrapper">
    <article class="heading-portion">
        <h3 class="heading-text mt-2">Exceeds the maximum limit</h3>
    </article>
    <article class="body-portion">
        <span class="body-text">
            Investment across all the products total 
            <strong>
                {{data.investmentAmount | currency:'INR'}}
            </strong>.
            The total investment amount exceeds the maximum investment amount of
            <strong>
                {{(data.investmentLimit ? data.investmentLimit/100000 : 50) | currency:'INR':'symbol':'0.0-0'}} lakhs
            </strong>
        </span>
    </article>
    <article class="footer mt-4 pt-4">
        <button class="btn-normal" (click)="onBackButtonClicked()">BACK</button>
    </article>
</section>
